import Store from "@/store/app";

let ENVIRONMENT = 'staging';

if (process.env.VUE_APP_ENVIRONMENT) {
  ENVIRONMENT = process.env.VUE_APP_ENVIRONMENT;
}

const getRoutes = store => {

  const checkAuth = (to, from, next) => {
    const accessToken = to.query?.accessToken;
    if (accessToken) {
      Store.commit('auth/setAccessToken', accessToken);
    }

    const
      data = {
        startDate: "2023-10-03T22:00:00.000Z",
        endDate: "2023-10-05T21:59:59.999Z"
      },
      activeProvider = to.meta.activeProvider,
      selectedProvider = to.meta.selectedProvider;

    Store.state.providerTenant = activeProvider;
    Store.state.providerUrl = activeProvider;

    Store.dispatch("auth/getSelf")
      .then(() => Promise.all(
        activeProvider ?
          [Store.dispatch(`${activeProvider}/stats/getStats`, data)] :
          [Store.dispatch("office/stats/getStats", data),
            Store.dispatch("google/stats/getStats", data),
            Store.dispatch("dropbox/stats/getStats", data),
            Store.dispatch("box/stats/getStats", data),
            Store.dispatch("salesforce/stats/getStats", data),]
      ))
      .then(() => {
        Store.state.auth.isLoading = false;
        next()
      })
      .catch(() => {
        Store.state.auth.isLoading = false;
        next({
          name: "SignInPage"
        });
      });
  }

  const checkNoAuth = (to, from, next) => {
    Store.state.auth.isLoading = false;
    if (Store.state.auth.accessToken) {
      next({
        name: "HomeLayout"
      });
    } else {
      next();
    }
  };

  const checkNoTenant = (to, from, next) => {
    if (Store.state.auth.self.providerTenants && Store.state.auth.self.providerTenants.length) {
      if (Store.getters['auth/isMicrosoftProviderEnabled']) {
        next({
          name: "MicrosoftHomePage",
          replace: true
        });
      } else if (Store.getters['auth/isGoogleProviderEnabled']) {
        next({
          name: "GoogleHomePage"
        });
      } else if (Store.getters['auth/isDropboxProviderEnabled']) {
        next({
          name: "DropboxHomePage"
        });
      } else if (Store.getters['auth/isBoxProviderEnabled']) {
        next({
          name: "BoxHomePage"
        });
      } else if (Store.getters['auth/isSalesforceProviderEnabled']) {
        next({
          name: "SalesforceObjectsPage"
        });
      } else {
        next();
      }

    } else {
      next();
    }
  };

  const singleSignOn = (routeName) => (to, from, next) => {
    Store.commit('auth/setAccessToken', to.params.token)
    next({
      name: routeName,
    });
  }

  const checkIsProviderConnected = (providerType) => (to, from, next) => {
    if (Store.getters['auth/isProviderConnected'](providerType)) {
      if (providerType === 1) {
        next({
          name: 'MicrosoftHomePage'
        })
      } else if (providerType === 2) {
        next({
          name: 'GoogleHomePage'
        })
      } else if (providerType === 3) {
        next({
          name: 'DropboxHomePage'
        })
      } else if (providerType === 4) {
        next({
          name: 'BoxHomePage'
        })
      } else if (providerType === 5) {
        next({
          name: 'SalesforceObjectsPage'
        })
      } else {
        next()
      }

    } else {
      next()
    }
  }

  const checkActiveUsers = (provider, stats) => {
    return stats?.reduce((acc, stat) => {
      return Store.state[provider]?.stats.stats[stat]?.activeUsers > 0;
    }, false);
  }

  const checkProviderTenant = (provider, routeName) => (to, from, next) => {
    if (Store.state.auth.self) {
      if (Store.getters[`auth/is${provider}ProviderEnabled`]) {
        if (Store.state.auth.self?.providerTenants?.find(item => item?.providerTenantName === provider)?.disableTime === null) {
          next()
        } else {
          next({
            name: 'AccountDisabled'
          })
        }
      } else {
        next({
          name: routeName
        })
      }
    } else {
      next({
        name: 'HomeLayout'
      })
    }
  }

  const checkHasProviderAccess = (accessLevels, tenantType) => (to, from, next) => {
    let providerLevelType = 0
    providerLevelType = Store?.state?.auth?.self?.providerTenants?.find(providerTenant => providerTenant?.providerTenantType === tenantType)?.levelType

    if (accessLevels.includes(providerLevelType)) {
      next({})
    } else {
      next({
        name: "HomeLayout"
      });
    }
  }

  const checkHasConnectedAccount = (provider, routeName, enabledModule) => async (to, from, next) => {
    try {
      await Store.dispatch(`${provider}/backupSettings/list`);
      const isEnabled = Store?.state[provider]?.backupSettings[enabledModule];
      if (isEnabled) {
        next();
      } else {
        if (to.name === routeName) {
          next();
        } else {
          next({name: routeName});
        }
      }

    } catch (error) {
      next({name: 'HomeLayout'});
    }
  }

  const checkMicrosoftTenant = (to, from, next) => {
    if (Store.state.auth.self) {
      if (to.name === 'MicrosoftWelcomePage' && to.query?.accessToken) {
        next();
      } else if (Store.getters['auth/isMicrosoftProviderEnabled']) {
        if (Store.state.auth.self?.providerTenants?.find(item => item?.providerTenantName === 'Microsoft')?.disableTime === null) {
          next()
        } else {
          next({
            name: 'AccountDisabled'
          })
        }
      } else {
        next({
          name: 'ConnectMicrosoftLayout'
        })
      }
    } else {
      next({
        name: 'HomeLayout'
      })
    }
  }

  const checkActiveMicrosoftUsers = (to, from, next) => {
    // if (checkActiveUsers('office', ['driveStats', 'exchangeStats', 'siteStats', 'teamStats']) || to.name === 'MicrosoftWelcomePage') {
    next();
    // } else {
    //   next({
    //     name: 'MicrosoftWelcomePage'
    //   })
    // }
  }

  const checkActiveGoogleUsers = (to, from, next) => {
    // if (checkActiveUsers('google', ['calendarStats', 'contactStats', 'googleSharedDriveStats', 'driveStats', 'googleMailStats']) || to.name === 'GoogleWelcomePage') {
    next();
    // } else {
    //   next({
    //     name: 'GoogleWelcomePage'
    //   })
    // }
  }

  const checkActiveDropboxUsers = (to, from, next) => {
    // if (checkActiveUsers('google', ['googleSharedFoldersStats', 'driveStats']) || to.name === 'DropboxWelcomePage') {
    next();
    // } else {
    //   next({
    //     name: 'DropboxWelcomePage'
    //   })
    // }
  }

  const checkActiveBoxUsers = (to, from, next) => {
    // if (checkActiveUsers('google', ['driveStats']) || to.name === 'BoxWelcomePage') {
    next();
    // } else {
    //   next({
    //     name: 'BoxWelcomePage'
    //   })
    // }
  }

  const checkActiveSalesforceUsers = (to, from, next) => {
    // if (checkActiveUsers('salesforce', ['driveStats']) || to.name === 'SalesforceWelcomePage') {
    next();
    // } else {
    //   next({
    //     name: 'SalesforceWelcomePage'
    //   })
    // }
  }

  const logoutAndRedirect = (from, to, next) => {
    Store.dispatch('auth/signOut', false)
      .then(() => {
        if (from.query.redirect_url) {
          window.location.href = from.query.redirect_url
        } else {
          if (Store.state.auth?.self?.platform === "360") {
            window.location.href = 'https://webapp.idrive360.com/api/v1/logout'
          } else {
            window.location.href = 'https://www.idrive.com/idriveent/login/logout'
          }
        }
        // next(true)

      })
  }


  const routes = [
    {
      path: '/auth',
      component: () => import('../../layout/AuthLayout'),
      beforeEnter: checkNoAuth,
      children: [
        {
          path: 'sign-up',
          name: 'SignUpPage',
          component: () => import('../../pages/app/auth/SignUpPage')
        },
        {
          path: 'sign-in',
          name: 'SignInPage',
          component: () => import('../../pages/app/auth/SignInPage')
        },
        {
          path: 'forgot-password',
          name: "ForgotPasswordPage",
          component: () => import('../../pages/app/auth/ForgotPasswordPage')
        },
      ]
    },
    {
      path: '/',
      component: () => import('../../layout/MainLayout'),
      beforeEnter: checkAuth,
      children: [
        // MICROSOFT365 START
        {
          path: '/microsoft-365/register-error',
          name: 'MicrosoftRegisterErrorPage',
          meta: {activeProvider: 'office', selectedProvider: 'MICROSOFT'},
          component: () => import('../../pages/app/auth/MicrosoftRegisterErrorPage')
        },
        {
          path: 'microsoft-365',
          component: () => import('../../layout/app/office/AppLayout'),
          beforeEnter: checkMicrosoftTenant,
          children: [
            {
              path: '',
              component: () => import('../../layout/PageLayout'),
              children: [
                {
                  path: 'welcome',
                  name: 'MicrosoftWelcomePage',
                  meta: {activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                  component: () => import('@/layout/app/office/WelcomePage'),
                  beforeEnter: checkActiveMicrosoftUsers,
                },
                {
                  path: 'home',
                  name: 'MicrosoftHomePage',
                  meta: {activeMenu: 'overview', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                  component: () => import('@/pages/app/common/overview/HomePage'),
                  beforeEnter: checkActiveMicrosoftUsers,
                },
                // {
                //   path: 'administrators',
                //   name: 'AdministratorsMicrosoftPage',
                //   meta: {activeMenu: 'administrators'},
                //   component: () => import('../pages/office/admin/AdministratorsPage'),
                // },
                {
                  path: 'reports',
                  name: 'OfficeReportsPage',
                  redirect: {name: 'OfficeSystemEventsPage'},
                  component: () => import('@/pages/app/common/activity-logs/ReportsPage'),
                  beforeEnter: checkActiveMicrosoftUsers,
                  children: [
                    {
                      path: 'system-events',
                      name: 'OfficeSystemEventsPage',
                      meta: {activeMenu: 'administrators', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/activity-logs/reporting/SystemEventsPage'),
                    },
                    {
                      path: 'user-actions',
                      name: 'OfficeUserActionsPage',
                      meta: {activeMenu: 'administrators', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/activity-logs/reporting/UserActionsPage'),
                    },
                    {
                      path: 'event-logs',
                      name: 'OfficeAllEventLogsPage',
                      meta: {activeMenu: 'administrators', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/activity-logs/reporting/AllEventLogsPage'),
                    },
                  ]
                },
                {
                  path: 'settings',
                  component: () => import('../../layout/PageLayout'),
                  beforeEnter: checkActiveMicrosoftUsers,
                  children: [
                    {
                      path: 'notifications',
                      name: 'OfficeNotificationsPage',
                      meta: {activeMenu: 'settings'},
                      component: () => import('../../pages/app/common/settings/NotificationPage.vue'),
                      props: {collection: 'notifications'},
                    },
                    // {
                    //   path: 'connections',
                    //   name: 'OfficeConnectionsPage',
                    //   meta: {activeMenu: 'settings'},
                    //   component: () => import('../../pages/app/common/settings/ConnectionsPage'),
                    //   props: {collection: 'connections'},
                    // },
                  ]
                },
              ],
            },
            {
              path: 'seat-management',
              component: () => import('../../layout/PageLayout'),
              beforeEnter: checkActiveMicrosoftUsers,
              children: [
                {
                  path: 'users',
                  name: 'UsersPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                  beforeEnter: checkHasProviderAccess([1, 3], 1),
                  component: () => import('@/pages/app/common/seat-management/SeatsPage'),
                  props: {collection: 'users'},
                },
                {
                  path: 'user-personal',
                  name: 'UserPersonalPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                  beforeEnter: checkHasProviderAccess([2], 1),
                  component: () => import('../../pages/app/office/seat-management/UserPersonalPage'),
                },
                {
                  path: 'sites',
                  name: 'SitesPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                  beforeEnter: checkHasProviderAccess([1, 3], 1),
                  component: () => import('@/pages/app/common/seat-management/SeatsPage'),
                  props: {collection: 'sites'},
                },
                {
                  path: 'teams',
                  name: 'TeamsPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                  beforeEnter: checkHasProviderAccess([1, 3], 1),
                  component: () => import('@/pages/app/common/seat-management/SeatsPage'),
                  props: {collection: 'teams'},
                },
                {
                  path: 'mailboxes',
                  name: 'MailboxesPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                  beforeEnter: checkHasProviderAccess([1, 3], 1),
                  component: () => import('@/pages/app/common/seat-management/SeatsPage'),
                  props: {collection: 'mailboxes'},
                },
              ],
            },
            {
              path: 'recovery',
              component: () => import('../../layout/PageLayout'),
              beforeEnter: checkActiveMicrosoftUsers,
              children: [
                {
                  path: 'onedrive',
                  name: 'OneDrivePage',
                  redirect: {name: 'OneDriveUsersPage'},
                  component: () => import('../../layout/PageLayout'),
                  props: {collection: 'oneDrive'},
                  children: [
                    {
                      path: 'users',
                      name: 'OneDriveUsersPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/UsersPage'),
                    },
                    {
                      path: 'users/:userId/:folderId?',
                      name: 'RecoveryOneDriveUserDetailsLayout',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/UserDetailsPage'),
                      props: true,
                    },
                    {
                      path: 'search',
                      name: 'OneDriveSearchPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      props: true,
                      component: () => import('@/pages/app/common/SearchPage'),
                    },
                    {
                      path: 'export',
                      name: 'OneDriveExportPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'OneDriveRestorePage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'OneDriveBackupPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/BackupPage'),
                    },
                  ]
                },
                {
                  path: 'outlook',
                  name: 'ExchangePage',
                  redirect: {name: 'ExchangeUsersPage'},
                  component: () => import('../../layout/PageLayout'),
                  props: {collection: 'exchange'},

                  children: [
                    {
                      path: 'users',
                      name: 'ExchangeUsersPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/UsersPage'),
                    },
                    {
                      path: 'users/:userId/:dataSet(mail|contact|calendar|task)/:folderId?',
                      name: 'RecoveryExchangeUserDetailsLayout',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/UserDetailsPage'),
                      // component: () => import('../layout/office/recovery/exchange/UserDetailsLayout'),
                      props: true,
                    },
                    {
                      path: 'search',
                      name: 'ExchangeSearchPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      props: true,
                      component: () => import('@/pages/app/common/SearchPage'),
                    },
                    {
                      path: 'export',
                      name: 'ExchangeExportPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'ExchangeRestorePage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      beforeEnter: checkHasProviderAccess([1, 3], 1),
                      component: () => import('@/pages/app/common/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'ExchangeBackupPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/BackupPage'),
                    },
                  ]
                },
                {
                  path: 'sharepoint',
                  name: 'SharePointPage',
                  redirect: {name: 'SharePointSitesPage'},
                  props: {collection: 'sharePoint'},
                  beforeEnter: checkHasProviderAccess([1, 3], 1),
                  component: () => import('../../layout/PageLayout'),
                  children: [
                    {
                      path: 'sites',
                      name: 'SharePointSitesPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/office/recovery/share-point/SitesPage'),
                    },
                    {
                      path: 'sites/:siteId/:dataSet(drive|list)/:folderId?',
                      name: 'RecoverySharePointSiteDetailsLayout',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/layout/app/office/recovery/share-point/SiteDetailsLayout'),
                      props: true,
                    },
                    {
                      path: 'search',
                      name: 'SharePointSearchPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/SearchPage'),
                    },
                    {
                      path: 'export',
                      name: 'SharePointExportPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'SharePointRestorePage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'SharePointBackupPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/BackupPage'),
                    },
                  ]
                },
                {
                  path: 'teams',
                  name: 'RTeamsPage',
                  redirect: {name: 'TeamsTeamsPage'},
                  beforeEnter: checkHasProviderAccess([1, 3], 1),
                  component: () => import('../../layout/PageLayout'),
                  props: {collection: 'team'},
                  children: [
                    {
                      path: 'teams',
                      name: 'TeamsTeamsPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('../../pages/app/office/recovery/team/TeamsPage'),
                    },
                    {
                      path: 'teams/:teamId/:dataSet(drive|conversation)/:channelId?/:folderId?',
                      name: 'RecoveryTeamDetailsLayout',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('../../layout/app/office/recovery/team/TeamDetailsLayout'),
                      props: true,
                    },
                    {
                      path: 'groups/:teamId/:dataSet(drive|mail|calendar|metadata)/:channelId?/:folderId?',
                      name: 'RecoveryGroupDetailsLayout',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('../../layout/app/office/recovery/team/GroupDetailsLayout'),
                      props: true,
                    },
                    {
                      path: 'search',
                      name: 'TeamSearchPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      props: true,
                      component: () => import('@/pages/app/common/SearchPage'),
                    },
                    {
                      path: 'export',
                      name: 'TeamExportPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'TeamRestorePage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'TeamBackupPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'office', selectedProvider: 'MICROSOFT'},
                      component: () => import('@/pages/app/common/BackupPage'),
                    },
                  ]
                },
              ]
            },
          ]
        },
        // MICROSOFT365 END
        {
          path: 'connect-google',
          name: 'ConnectGoogleLayout',
          meta: {activeProvider: 'google', selectedProvider: 'GOOGLE'},
          component: () => import('../../layout/app/google/ConnectAccountLayout'),
          beforeEnter: checkNoTenant && !checkProviderTenant('Google', 'ConnectGoogleLayout') || checkIsProviderConnected(2)
        },
        {
          path: 'connect-microsoft',
          name: 'ConnectMicrosoftLayout',
          meta: {activeProvider: 'office', selectedProvider: 'MICROSOFT'},
          component: () => import('../../layout/app/office/ConnectAccountLayout'),
          beforeEnter: checkNoTenant && !checkMicrosoftTenant || checkIsProviderConnected(1)
        },
        {
          path: 'connect-dropbox',
          name: 'ConnectDropboxLayout',
          meta: {activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
          component: () => import('../../layout/app/dropbox/ConnectAccountLayout'),
          beforeEnter: checkNoTenant && !checkProviderTenant('Dropbox', 'ConnectDropboxLayout') || checkIsProviderConnected(3)
        },
        {
          path: '/dropbox/register-error',
          name: 'DropboxWorkspaceRegisterErrorPage',
          meta: {activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
          component: () => import('../../pages/app/auth/DropboxWorkspaceRegisterErrorPage')
        },
        {
          path: 'connect-box',
          name: 'ConnectBoxLayout',
          meta: {activeProvider: 'box', selectedProvider: 'BOX'},
          component: () => import('../../layout/app/box/ConnectAccountLayout'),
          beforeEnter: checkNoTenant && !checkProviderTenant('Box', 'ConnectBoxLayout') || checkIsProviderConnected(4)
        },
        {
          path: '/box/register-error',
          name: 'BoxWorkspaceRegisterErrorPage',
          meta: {activeProvider: 'box', selectedProvider: 'BOX'},
          component: () => import('../../pages/app/auth/BoxWorkspaceRegisterErrorPage')
        },
        {
          path: 'connect-salesforce',
          name: 'ConnectSalesforceLayout',
          component: () => import('../../layout/app/salesforce/ConnectAccountLayout'),
          beforeEnter: checkNoTenant && !checkProviderTenant('Salesforce', 'ConnectSalesforceLayout') || checkIsProviderConnected(5)
        },
        {
          path: '/salesforce/register-error',
          name: 'SalesforceWorkspaceRegisterErrorPage',
          component: () => import('../../pages/app/auth/SalesforceWorkspaceRegisterErrorPage')
        },
        {
          path: 'add-googleworkspace',
          name: 'GoogleWorkspaceLayout',
          component: () => import('../../layout/app/google/GoogleWorkspaceLayout'),
          beforeEnter: checkNoTenant && !checkProviderTenant('Google', 'ConnectGoogleLayout') || checkIsProviderConnected(2)
        },
        {
          path: '/google/register-error',
          name: 'GoogleWorkspaceRegisterErrorPage',
          component: () => import('../../pages/app/auth/GoogleWorkspaceRegisterErrorPage')
        },
        // GOOGLE START
        {
          path: 'google',
          component: () => import('../../layout/app/google/AppLayout'),
          beforeEnter: checkProviderTenant('Google', 'ConnectGoogleLayout'),
          children: [
            {
              path: '',
              component: () => import('../../layout/PageLayout'),
              children: [
                {
                  path: 'welcome',
                  name: 'GoogleWelcomePage',
                  meta: {activeProvider: 'google', selectedProvider: 'GOOGLE'},
                  component: () => import('../../layout/app/google/WelcomePage'),
                  beforeEnter: checkActiveGoogleUsers,
                },
                {
                  path: 'home',
                  name: 'GoogleHomePage',
                  meta: {activeMenu: 'overview', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                  component: () => import('@/pages/app/common/overview/HomePage'),
                  beforeEnter: checkActiveGoogleUsers,
                },
                // {
                //   path: 'administrators',
                //   name: 'AdministratorsGooglePage',
                //   meta: {activeMenu: 'administrators'},
                //   component: () => import('../pages/office/admin/AdministratorsPage'),
                // },
                {
                  path: 'reports',
                  name: 'GoogleReportsPage',
                  redirect: {name: 'GoogleSystemEventsPage'},
                  meta: {activeProvider: 'google', selectedProvider: 'GOOGLE'},
                  component: () => import('@/pages/app/common/activity-logs/ReportsPage'),
                  beforeEnter: checkActiveGoogleUsers,
                  children: [
                    {
                      path: 'system-events',
                      name: 'GoogleSystemEventsPage',
                      meta: {activeMenu: 'administrators', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/activity-logs/reporting/SystemEventsPage'),
                    },
                    {
                      path: 'user-actions',
                      name: 'GoogleUserActionsPage',
                      meta: {activeMenu: 'administrators', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/activity-logs/reporting/UserActionsPage'),
                    },
                    {
                      path: 'event-logs',
                      name: 'GoogleAllEventLogsPage',
                      meta: {activeMenu: 'administrators', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/activity-logs/reporting/AllEventLogsPage'),
                    },
                  ]
                },
                {
                  path: 'settings',
                  component: () => import('../../layout/PageLayout'),
                  beforeEnter: checkActiveGoogleUsers,
                  children: [
                    {
                      path: 'notifications',
                      name: 'GoogleNotificationsPage',
                      meta: {activeMenu: 'settings'},
                      component: () => import('../../pages/app/common/settings/NotificationPage'),
                      props: {collection: 'notifications'},
                    },
                    // {
                    //   path: 'connections',
                    //   name: 'GoogleConnectionsPage',
                    //   meta: {activeMenu: 'settings'},
                    //   component: () => import('../../pages/app/common/settings/ConnectionsPage'),
                    //   props: {collection: 'connections'},
                    // },
                  ]
                }
              ],
            },
            {
              path: 'seat-management',
              meta: {activeProvider: 'google', selectedProvider: 'GOOGLE'},
              component: () => import('../../layout/PageLayout'),
              beforeEnter: checkActiveGoogleUsers,
              children: [
                {
                  path: 'users',
                  name: 'GUsersPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                  beforeEnter: checkHasProviderAccess([1, 3], 2),
                  component: () => import('@/pages/app/common/seat-management/SeatsPage'),
                  props: {collection: 'users'},
                },
                {
                  path: 'user-personal',
                  name: 'GUserPersonalPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                  beforeEnter: checkHasProviderAccess([2], 2),
                  component: () => import('../../pages/app/google/seat-management/UserPersonalPage'),
                },
                {
                  path: 'shared-drives',
                  name: 'SMSharedDrivePage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                  beforeEnter: checkHasProviderAccess([1, 3], 2),
                  component: () => import('@/pages/app/common/seat-management/SeatsPage'),
                  props: {collection: 'sharedDrives'},
                },
                {
                  path: 'classrooms',
                  name: 'SMClassroomPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                  beforeEnter: checkHasProviderAccess([1, 3], 2) && checkHasConnectedAccount('google', 'SMConnectAccountPage', 'enabledClassroom'),
                  component: () => import('@/pages/app/common/seat-management/SeatsPage'),
                  props: {collection: 'classrooms'},
                },
                {
                  path: 'classrooms/connect',
                  name: 'SMConnectAccountPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                  beforeEnter: checkHasProviderAccess([1, 3], 2) && checkHasConnectedAccount('google', 'SMConnectAccountPage', 'enabledClassroom'),
                  component: () => import('@/pages/app/common/ConnectAccountPage'),
                  props: {collection: 'classrooms'},
                },
              ],
            },
            {
              path: 'recovery',
              meta: {activeProvider: 'google', selectedProvider: 'GOOGLE'},
              component: () => import('../../layout/PageLayout'),
              beforeEnter: checkActiveGoogleUsers,
              children: [
                {
                  path: 'drive',
                  name: 'DrivePage',
                  redirect: {name: 'DriveUsersPage'},
                  component: () => import('../../layout/PageLayout'),
                  props: {collection: 'drive'},

                  children: [
                    {
                      path: 'users',
                      name: 'DriveUsersPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/UsersPage'),
                    },
                    {
                      path: 'search',
                      name: 'DriveSearchPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/SearchPage'),
                    },

                    {
                      path: 'users/:userId/:folderId?',
                      name: 'RecoveryDriveUserDetailsLayout',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/UserDetailsPage'),
                      props: true,
                    },

                    {
                      path: 'exports',
                      name: 'DriveExportPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'DriveRestoresPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'DriveBackupsPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/BackupPage'),
                    },
                  ]
                },
                {
                  path: 'gmail',
                  name: 'GmailPage',
                  redirect: {name: 'GmailUsersPage'},
                  component: () => import('../../layout/PageLayout'),
                  props: {collection: 'gmail'},
                  children: [
                    {
                      path: 'users',
                      name: 'GmailUsersPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/UsersPage'),
                    },
                    {
                      path: 'users/:userId/:dataSet(folders|mails)/:folderId?',
                      name: 'RecoveryGmailUserDetailsLayout',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/UserDetailsPage'),
                      props: true,
                    },
                    {
                      path: 'search',
                      name: 'GmailSearchPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/SearchPage'),
                    },
                    {
                      path: 'export',
                      name: 'GmailExportPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'GmailRestorePage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'GmailBackupPage',
                      meta: {activeMenu: 'recovery'},
                      component: () => import('@/pages/app/common/BackupPage'),
                    },
                  ]
                },
                {
                  path: 'contact',
                  name: 'ContactPage',
                  redirect: {name: 'ContactUsersPage'},
                  component: () => import('../../layout/PageLayout'),
                  props: {collection: 'contact'},
                  children: [
                    {
                      path: 'users',
                      name: 'ContactUsersPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/UsersPage'),
                    },
                    {
                      path: 'users/:userId/:folderId?',
                      name: 'RecoveryContactUserDetailsLayout',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/UserDetailsPage'),
                      props: true,
                    },
                    {
                      path: 'search',
                      name: 'ContactSearchPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/SearchPage'),
                    },
                    {
                      path: 'export',
                      name: 'ContactExportPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'ContactRestorePage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'ContactBackupPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/BackupPage'),
                    },
                  ]
                },
                {
                  path: 'calendar',
                  name: 'CalendarPage',
                  redirect: {name: 'CalendarUsersPage'},
                  component: () => import('../../layout/PageLayout'),
                  props: {collection: 'calendar', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                  children: [
                    {
                      path: 'users',
                      name: 'CalendarUsersPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/UsersPage'),
                    },
                    {
                      path: 'users/:userId/:folderId?',
                      name: 'RecoveryCalendarUserDetailsLayout',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/UserDetailsPage'),
                      props: true,
                    },
                    {
                      path: 'search',
                      name: 'CalendarSearchPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/SearchPage'),
                    },
                    {
                      path: 'export',
                      name: 'CalendarExportPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'CalendarRestorePage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'CalendarBackupPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/BackupPage'),
                    },
                  ]
                },
                {
                  path: 'shared-drives',
                  name: 'RSharedDrivesPage',
                  redirect: {name: 'SharedDrivesPage'},
                  beforeEnter: checkHasProviderAccess([1, 3], 2),
                  component: () => import('../../layout/PageLayout'),
                  props: {collection: 'sharedDrive'},

                  children: [
                    {
                      path: 'shared-drives',
                      name: 'SharedDrivesPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/google/recovery/shared-drive/SharedDrivesPage'),
                    },
                    {
                      path: 'shared-drives/:sharedDriveId/:folderId?',
                      name: 'RecoverySharedDriveDetailsLayout',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/layout/app/google/recovery/shared-drive/SharedDriveDetailsLayout'),
                      props: true,
                    },
                    {
                      path: 'search',
                      name: 'SharedDriveSearchPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      props: true,
                      component: () => import('@/pages/app/common/SearchPage'),
                    },
                    {
                      path: 'export',
                      name: 'SharedDriveExportPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'SharedDriveRestorePage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'SharedDriveBackupPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/BackupPage'),
                    },
                  ]
                },
                {
                  path: 'classrooms',
                  name: 'RClassroomsPage',
                  redirect: {name: 'ClassroomsPage'},
                  beforeEnter: checkHasProviderAccess([1, 3], 2),
                  component: () => import('../../layout/PageLayout'),
                  props: {collection: 'classroom'},

                  children: [
                    {
                      path: 'connect',
                      name: 'ConnectAccountPage',
                      beforeEnter: checkHasConnectedAccount('google', 'ConnectAccountPage', 'enabledClassroom'),
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/ConnectAccountPage'),
                      props: {collection: 'classroom'},
                    },
                    {
                      path: 'classrooms',
                      name: 'ClassroomsPage',
                      beforeEnter: checkHasConnectedAccount('google', 'ConnectAccountPage', 'enabledClassroom'),
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/google/recovery/classroom/ClassroomsPage'),
                    },
                    {
                      path: 'classrooms/:classroomId/:dataSet(announcement|classwork|drive|grade|people)/:folderId?',
                      name: 'RecoveryClassroomDetailsLayout',
                      beforeEnter: checkHasConnectedAccount('google', 'ConnectAccountPage', 'enabledClassroom'),
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/layout/app/google/recovery/classroom/ClassroomDetailsLayout'),
                      props: true,
                    },
                    {
                      path: 'search',
                      name: 'ClassroomSearchPage',
                      beforeEnter: checkHasConnectedAccount('google', 'ConnectAccountPage', 'enabledClassroom'),
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      props: true,
                      component: () => import('@/pages/app/common/SearchPage'),
                    },
                    {
                      path: 'export',
                      name: 'ClassroomExportPage',
                      beforeEnter: checkHasConnectedAccount('google', 'ConnectAccountPage', 'enabledClassroom'),
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'ClassroomRestorePage',
                      beforeEnter: checkHasConnectedAccount('google', 'ConnectAccountPage', 'enabledClassroom'),
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'ClassroomBackupPage',
                      beforeEnter: checkHasConnectedAccount('google', 'ConnectAccountPage', 'enabledClassroom'),
                      meta: {activeMenu: 'recovery', activeProvider: 'google', selectedProvider: 'GOOGLE'},
                      component: () => import('@/pages/app/common/BackupPage'),
                    },
                  ]
                },
              ]
            },
          ]
        },
        // GOOGLE END

        // DROPBOX START
        {
          path: 'dropbox',
          component: () => import('../../layout/app/dropbox/AppLayout'),
          beforeEnter: checkProviderTenant('Dropbox', 'ConnectDropboxLayout'),
          children: [
            {
              path: '',
              component: () => import('../../layout/PageLayout'),
              children: [
                {
                  path: 'welcome',
                  name: 'DropboxWelcomePage',
                  meta: {activeProvider: 'google', selectedProvider: 'GOOGLE'},
                  component: () => import('../../layout/app/dropbox/WelcomePage'),
                  beforeEnter: checkActiveDropboxUsers,
                },
                {
                  path: 'home',
                  name: 'DropboxHomePage',
                  meta: {activeMenu: 'overview', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                  component: () => import('@/pages/app/common/overview/HomePage'),
                  beforeEnter: checkActiveDropboxUsers,
                },
                // {
                //   path: 'administrators',
                //   name: 'AdministratorsGooglePage',
                //   meta: {activeMenu: 'administrators'},
                //   component: () => import('../pages/office/admin/AdministratorsPage'),
                // },
                {
                  path: 'reports',
                  name: 'DropboxReportsPage',
                  redirect: {name: 'DropboxSystemEventsPage'},
                  component: () => import('@/pages/app/common/activity-logs/ReportsPage'),
                  beforeEnter: checkActiveDropboxUsers,
                  children: [
                    {
                      path: 'system-events',
                      name: 'DropboxSystemEventsPage',
                      meta: {activeMenu: 'administrators', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/pages/app/common/activity-logs/reporting/SystemEventsPage'),
                    },
                    {
                      path: 'user-actions',
                      name: 'DropboxUserActionsPage',
                      meta: {activeMenu: 'administrators', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/pages/app/common/activity-logs/reporting/UserActionsPage'),
                    },
                    {
                      path: 'event-logs',
                      name: 'DropboxAllEventLogsPage',
                      meta: {activeMenu: 'administrators', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/pages/app/common/activity-logs/reporting/AllEventLogsPage'),
                    },
                  ]
                },
                {
                  path: 'settings',
                  component: () => import('../../layout/PageLayout'),
                  beforeEnter: checkActiveDropboxUsers,
                  children: [
                    {
                      path: 'notifications',
                      name: 'DropboxNotificationsPage',
                      meta: {activeMenu: 'settings'},
                      component: () => import('../../pages/app/common/settings/NotificationPage'),
                      props: {collection: 'notifications'},
                    },
                    // {
                    //   path: 'connections',
                    //   name: 'DropboxConnectionsPage',
                    //   meta: {activeMenu: 'settings'},
                    //   component: () => import('../../pages/app/common/settings/ConnectionsPage'),
                    //   props: {collection: 'connections'},
                    // },
                  ]
                }
              ],
            },
            {
              path: 'seat-management',
              component: () => import('../../layout/PageLayout'),
              children: [
                {
                  path: 'users',
                  name: 'DropboxUsersPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                  beforeEnter: checkHasProviderAccess([1, 3], 3),
                  component: () => import('@/pages/app/common/seat-management/SeatsPage'),
                  props: {collection: 'users'},
                },
                {
                  path: 'shared-folders',
                  name: 'SMSharedFolderPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                  beforeEnter: checkHasProviderAccess([1, 2, 3], 3),
                  component: () => import('@/pages/app/common/seat-management/SeatsPage'),
                  props: {collection: 'sharedFolders'},
                },
                {
                  path: 'user-personal',
                  name: 'DropboxUserPersonalPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                  beforeEnter: checkHasProviderAccess([2], 3),
                  component: () => import('../../pages/app/dropbox/seat-management/UserPersonalPage'),
                },
              ],
            },
            {
              path: 'recovery',
              component: () => import('../../layout/PageLayout'),
              children: [
                {
                  path: 'drive',
                  name: 'DropboxDrivePage',
                  redirect: {name: 'DropboxDriveUsersPage'},
                  component: () => import('../../layout/PageLayout'),
                  props: {collection: 'dropboxDrive'},

                  children: [
                    {
                      path: 'users',
                      name: 'DropboxDriveUsersPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/pages/app/common/UsersPage'),
                    },
                    {
                      path: 'search',
                      name: 'DropboxDriveSearchPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/pages/app/common/SearchPage'),
                    },
                    {
                      path: 'users/:userId/:folderId?',
                      name: 'RecoveryDropboxDriveUserDetailsLayout',
                      meta: {activeMenu: 'recovery', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/pages/app/common/UserDetailsPage'),
                      props: true,
                    },

                    {
                      path: 'exports',
                      name: 'DropboxDriveExportPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/pages/app/common/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'DropboxDriveRestoresPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/pages/app/common/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'DropboxDriveBackupsPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/pages/app/common/BackupPage'),
                    },
                  ]
                },
                {
                  path: 'shared-folders',
                  name: 'RSharedFoldersPage',
                  redirect: {name: 'SharedFoldersPage'},
                  component: () => import('../../layout/PageLayout'),
                  props: {collection: 'sharedFolder'},

                  children: [
                    {
                      path: 'shared-folders',
                      name: 'SharedFoldersPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/pages/app/dropbox/recovery/shared-folder/SharedFoldersPage'),
                    },
                    {
                      path: 'shared-folders/:sharedFolderId/:folderId?',
                      name: 'RecoverySharedFolderDetailsLayout',
                      meta: {activeMenu: 'recovery', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/layout/app/dropbox/recovery/shared-folder/SharedFolderDetailsLayout'),
                      props: true,
                    },
                    {
                      path: 'search',
                      name: 'SharedFolderSearchPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      props: true,
                      component: () => import('@/pages/app/common/SearchPage'),
                    },
                    {
                      path: 'export',
                      name: 'SharedFolderExportPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/pages/app/common/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'SharedFolderRestorePage',
                      meta: {activeMenu: 'recovery', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/pages/app/common/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'SharedFolderBackupPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'dropbox', selectedProvider: 'DROPBOX'},
                      component: () => import('@/pages/app/common/BackupPage'),
                    },
                  ]
                },
              ]
            },
          ]
        },
        // DROPBOX END

        // BOX START
        {
          path: 'box',
          component: () => import('../../layout/app/box/AppLayout'),
          beforeEnter: checkProviderTenant('Box', 'ConnectBoxLayout'),
          children: [
            {
              path: '',
              component: () => import('../../layout/PageLayout'),
              children: [
                {
                  path: 'welcome',
                  name: 'BoxWelcomePage',
                  meta: {activeProvider: 'google', selectedProvider: 'GOOGLE'},
                  component: () => import('../../layout/app/box/WelcomePage'),
                  beforeEnter: checkActiveBoxUsers,
                },
                {
                  path: 'home',
                  name: 'BoxHomePage',
                  meta: {activeMenu: 'overview', activeProvider: 'box', selectedProvider: 'BOX'},
                  component: () => import('@/pages/app/common/overview/HomePage'),
                  beforeEnter: checkActiveBoxUsers,
                },
                {
                  path: 'reports',
                  name: 'BoxReportsPage',
                  redirect: {name: 'BoxSystemEventsPage', activeProvider: 'box', selectedProvider: 'BOX'},
                  component: () => import('@/pages/app/common/activity-logs/ReportsPage'),
                  beforeEnter: checkActiveBoxUsers,
                  children: [
                    {
                      path: 'system-events',
                      name: 'BoxSystemEventsPage',
                      meta: {activeMenu: 'administrators', activeProvider: 'box', selectedProvider: 'BOX'},
                      component: () => import('@/pages/app/common/activity-logs/reporting/SystemEventsPage'),
                    },
                    {
                      path: 'user-actions',
                      name: 'BoxUserActionsPage',
                      meta: {activeMenu: 'administrators', activeProvider: 'box', selectedProvider: 'BOX'},
                      component: () => import('@/pages/app/common/activity-logs/reporting/UserActionsPage'),
                    },
                    {
                      path: 'event-logs',
                      name: 'BoxAllEventLogsPage',
                      meta: {activeMenu: 'administrators', activeProvider: 'box', selectedProvider: 'BOX'},
                      component: () => import('@/pages/app/common/activity-logs/reporting/AllEventLogsPage'),
                    },
                  ]
                },
                {
                  path: 'settings',
                  component: () => import('../../layout/PageLayout'),
                  beforeEnter: checkActiveBoxUsers,
                  children: [
                    {
                      path: 'notifications',
                      name: 'BoxNotificationsPage',
                      meta: {activeMenu: 'settings'},
                      component: () => import('../../pages/app/common/settings/NotificationPage'),
                      props: {collection: 'notifications'},
                    },
                    // {
                    //   path: 'connections',
                    //   name: 'BoxConnectionsPage',
                    //   meta: {activeMenu: 'settings'},
                    //   component: () => import('../../pages/app/common/settings/ConnectionsPage'),
                    //   props: {collection: 'connections'},
                    // },
                  ]
                }
              ],
            },
            {
              path: 'seat-management',
              component: () => import('../../layout/PageLayout'),
              beforeEnter: checkActiveBoxUsers,
              children: [
                {
                  path: 'users',
                  name: 'BoxUsersPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'box', selectedProvider: 'BOX'},
                  beforeEnter: checkHasProviderAccess([1, 3], 4),
                  component: () => import('@/pages/app/common/seat-management/SeatsPage'),
                  props: {collection: 'users'},
                },
                {
                  path: 'user-personal',
                  name: 'BoxUserPersonalPage',
                  meta: {activeMenu: 'seat-management', activeProvider: 'box', selectedProvider: 'BOX'},
                  beforeEnter: checkHasProviderAccess([2], 4),
                  component: () => import('../../pages/app/box/seat-management/UserPersonalPage'),
                },
              ],
            },
            {
              path: 'recovery',
              component: () => import('../../layout/PageLayout'),
              beforeEnter: checkActiveBoxUsers,
              children: [
                {
                  path: 'drive',
                  name: 'BoxDrivePage',
                  redirect: {name: 'BoxDriveUsersPage'},
                  component: () => import('../../layout/PageLayout'),
                  props: {collection: 'boxDrive'},
                  children: [
                    {
                      path: 'users',
                      name: 'BoxDriveUsersPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'box', selectedProvider: 'BOX'},
                      component: () => import('@/pages/app/common/UsersPage'),
                    },
                    {
                      path: 'search',
                      name: 'BoxDriveSearchPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'box', selectedProvider: 'BOX'},
                      component: () => import('@/pages/app/common/SearchPage'),
                    },
                    {
                      path: 'users/:userId/:folderId?',
                      name: 'RecoveryBoxDriveUserDetailsLayout',
                      meta: {activeMenu: 'recovery', activeProvider: 'box', selectedProvider: 'BOX'},
                      component: () => import('@/pages/app/common/UserDetailsPage'),
                      props: true,
                    },

                    {
                      path: 'exports',
                      name: 'BoxDriveExportPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'box', selectedProvider: 'BOX'},
                      component: () => import('@/pages/app/common/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'BoxDriveRestoresPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'box', selectedProvider: 'BOX'},
                      component: () => import('@/pages/app/common/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'BoxDriveBackupsPage',
                      meta: {activeMenu: 'recovery', activeProvider: 'box', selectedProvider: 'BOX'},
                      component: () => import('@/pages/app/common/BackupPage'),
                    },
                  ]
                },
              ]
            },
          ]
        },
        // BOX END

        // SALESFORCE START
        {
          path: 'salesforce',
          component: () => import('../../layout/app/salesforce/AppLayout'),
          beforeEnter: checkProviderTenant('Salesforce', 'ConnectSalesforceLayout'),
          children: [
            {
              path: '',
              component: () => import('../../layout/PageLayout'),
              children: [
                {
                  path: 'welcome',
                  name: 'SalesforceWelcomePage',
                  component: () => import('../../layout/app/salesforce/WelcomePage'),
                  beforeEnter: checkActiveSalesforceUsers,
                },
                {
                  path: 'activity-logs',
                  name: 'ActivityLogsPage',
                  redirect: {name: 'SalesforceSystemEventsPage'},
                  meta: {activeProvider: 'salesforce', selectedProvider: 'SALESFORCE'},
                  component: () => import('@/pages/app/common/activity-logs/ReportsPage.vue'),
                  beforeEnter: checkActiveSalesforceUsers,
                  children: [
                    {
                      path: '',
                      component: () => import('../../layout/PageLayout'),
                      children: [
                        {
                          path: 'system-events',
                          name: 'SalesforceSystemEventsPage',
                          meta: {
                            activeMenu: 'administrators',
                            activeProvider: 'salesforce',
                            selectedProvider: 'SALESFORCE'
                          },
                          component: () => import('@/pages/app/salesforce/activity-logs/SystemEventsPage.vue'),
                        },
                        {
                          path: 'user-actions',
                          name: 'SalesforceUserActionsPage',
                          meta: {
                            activeMenu: 'administrators',
                            activeProvider: 'salesforce',
                            selectedProvider: 'SALESFORCE'
                          },
                          component: () => import('@/pages/app/salesforce/activity-logs/AdminActionsPage.vue'),
                        },
                        {
                          path: 'event-logs',
                          name: 'SalesforceAllEventLogsPage',
                          meta: {
                            activeMenu: 'administrators',
                            activeProvider: 'salesforce',
                            selectedProvider: 'SALESFORCE'
                          },
                          component: () => import('@/pages/app/salesforce/activity-logs/AllEventLogsPage.vue'),
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'dashboard',
              component: () => import('../../layout/PageLayout'),
              beforeEnter: checkActiveSalesforceUsers,
              props: {collection: 'object'},
              children: [
                {
                  path: 'salesforce',
                  name: 'SalesforcePage',
                  redirect: {name: 'SalesforceObjectsPage'},
                  component: () => import('../../layout/PageLayout'),
                  props: {collection: 'salesforce'},

                  children: [
                    {
                      path: 'exports',
                      name: 'SalesforceExportPage',
                      meta: {activeMenu: 'dashboard', activeProvider: 'salesforce', selectedProvider: 'SALESFORCE'},
                      component: () => import('@/pages/app/salesforce/recovery/ExportPage'),
                    },
                    {
                      path: 'restores',
                      name: 'SalesforceRestorePage',
                      meta: {activeMenu: 'dashboard', activeProvider: 'salesforce', selectedProvider: 'SALESFORCE'},
                      component: () => import('@/pages/app/salesforce/recovery/RestorePage'),
                    },
                    {
                      path: 'backups',
                      name: 'SalesforceBackupPage',
                      meta: {activeMenu: 'dashboard', activeProvider: 'salesforce', selectedProvider: 'SALESFORCE'},
                      component: () => import('@/pages/app/salesforce/recovery/BackupPage'),
                    },
                  ],
                },
                {
                  path: 'objects',
                  name: 'SalesforceObjectsPage',
                  meta: {activeMenu: 'dashboard', activeProvider: 'salesforce', selectedProvider: 'SALESFORCE'},
                  component: () => import('@/pages/app/salesforce/recovery/ObjectsPage'),
                },
                {
                  path: 'compares',
                  name: 'SalesforceComparesPage',
                  meta: {activeMenu: 'dashboard', activeProvider: 'salesforce', selectedProvider: 'SALESFORCE'},
                  component: () => import('@/pages/app/salesforce/recovery/ComparesPage'),
                },
                // {
                //   path: 'seeding',
                //   name: 'SalesforceSeedingPage',
                //   meta: {activeMenu: 'dashboard', activeProvider: 'salesforce', selectedProvider: 'SALESFORCE'},
                //   component: () => import('@/pages/app/salesforce/recovery/seeding/SeedingPage.vue'),
                // },
                // {
                //   path: 'seeding/:id',
                //   props: true,
                //   name: 'SalesforceSeedingTemplateDetailsPage',
                //   meta: {activeMenu: 'dashboard', activeProvider: 'salesforce', selectedProvider: 'SALESFORCE'},
                //   component: () => import('@/pages/app/salesforce/recovery/seeding/SeedingTemplateDetailsPage.vue'),
                // },
              ],
            },
            {
              path: '',
              component: () => import('../../layout/PageLayout'),
              beforeEnter: checkActiveSalesforceUsers,
              props: {collection: 'salesforce'},
              children: [
                {
                  path: 'seats',
                  name: 'SalesforceSeatsPage',
                  meta: {activeMenu: 'seats', activeProvider: 'salesforce', selectedProvider: 'SALESFORCE'},
                  component: () => import('@/pages/app/salesforce/SalesforceSeatsPage.vue'),
                },
              ]
            },
            {
              path: 'settings',
              component: () => import('../../layout/PageLayout'),
              beforeEnter: checkActiveSalesforceUsers,
              props: {collection: 'salesforce'},
              children: [
                {
                  path: 'notifications',
                  name: 'SalesforceNotificationsPage',
                  meta: {activeMenu: 'settings'},
                  component: () => import('../../pages/app/common/settings/NotificationPage'),
                  props: {collection: 'notifications'},
                },
                {
                  path: 'connections',
                  name: 'SalesforceConnectionsPage',
                  meta: {activeMenu: 'settings'},
                  component: () => import('../../pages/app/common/settings/ConnectionsPage'),
                  props: {collection: 'connections'},
                },
                // {
                //   path: 'settings',
                //   name: 'SalesforceSettingsPage',
                //   meta: {activeMenu: 'settings'},
                //   component: () => import('../../pages/app/common/SettingsPage.vue'),
                // }
              ]
            },
          ]
        },
        // SALESFORCE END

        {
          path: '',
          name: 'HomeLayout',
          component: () => import('@/layout/app/HomeLayout'),
        }
      ]
    },
    {
      path: '/account-disabled',
      name: 'AccountDisabled',
      component: () => import('@/pages/app/auth/AccountDisabled'),
    },
    {
      path: '/google-workspace-error-page',
      name: 'PublicGoogleErrorPage',
      component: () => import('@/pages/app/google/PublicGoogleErrorPage'),
    },
    {
      path: '/sso/microsoft/:token',
      beforeEnter: singleSignOn('MicrosoftHomePage'),
    },
    {
      path: '/sso/google/:token',
      beforeEnter: singleSignOn('GoogleHomePage'),
    },
    {
      path: '/sso/dropbox/:token',
      beforeEnter: singleSignOn('DropboxHomePage'),
    },
    {
      path: '/sso/box/:token',
      beforeEnter: singleSignOn('BoxHomePage'),
    },
    {
      path: '/sso/salesforce/:token',
      beforeEnter: singleSignOn('SalesforceObjectsPage'),
    },
    {
      path: '/sso/common/:token',
      beforeEnter: singleSignOn('HomeLayout'),
    },
    {
      path: '/logout',
      name: 'LogoutPage',
      component: () => import('../../pages/LogoutPage'),
    },
    {
      path: '/sign-in-test',
      name: 'SignInTestPage',
      component: () => import('../../pages/app/auth/SignInTestPage')
    },
    {
      path: '/logout/redirect',
      name: 'LogoutAndRedirectPage',
      component: () => import('@/pages/LogoutPage'),
      beforeEnter: logoutAndRedirect,
    },
    {
      path: '/admin-consent',
      name: 'AdminConsent',
      component: () => import('@/pages/app/office/AdminConsentPage')
    },
    {
      path: '/offline',
      name: 'OfflinePage',
      component: () => import('@/pages/OfflinePage'),
      beforeEnter: checkAuth,
    },
    // Always leave this as last one
    {
      path: '*',
      name: 'ErrorPage',
      component: () => import('@/pages/ErrorPage'),
      beforeEnter: checkAuth,
    }
  ]

  return routes;
}

export {getRoutes};
